module.exports = __webpack_public_path__ + "static/media/add_retooling.b72e72ac.png";